module.exports = __webpack_public_path__ + "img/expostyle_0915_mousy_grey.ba96aa3e.jpg";